import { useTranslation } from 'react-i18next';

import { Checkbox, UiButton, UiText } from '@shared/ui';

import cls from './NotificationSettings.module.css';
import { useNotificationSettings } from '../../model/useNotificationSettings';

import type { Profile } from '@entities/profile';

type NotificationSettingsProps = {
    profile: Profile;
};

export const NotificationSettings = ({ profile }: NotificationSettingsProps) => {
    const { t } = useTranslation();
    const {
        enabledNotifications,
        toggleNotification,
        selectAll,
        clearAll,
        save,
        isPending,
    } = useNotificationSettings(profile);

    return (
        <section className={cls.settingsSection}>
            <UiText tag="h3" variant="subHeading" weight="bold">
                {t('profile.page.settings.notifications.title')}
            </UiText>
            <div className={cls.notificationsHeader}>
                <UiText>{t('profile.page.settings.notifications.label')}</UiText>
                <UiButton
                    type="button"
                    variant="text"
                    className={cls.settingsLinkButton}
                    btnText={t('button.selectAll.text')}
                    disabled={isPending}
                    onClick={selectAll}
                />
                <UiButton
                    type="button"
                    variant="text"
                    className={cls.settingsLinkButton}
                    btnText={t('profile.page.settings.notifications.clearAll')}
                    disabled={isPending}
                    onClick={clearAll}
                />
            </div>
            <div className={cls.notificationsList}>
                {profile.notificationSubscriptions.map(({ eventName, title }) => (
                    <Checkbox
                        key={eventName}
                        isActive={enabledNotifications.has(eventName)}
                        onClick={() => toggleNotification(eventName)}
                        classes={cls.notificationCheckbox}
                    >
                        <UiText>{title}</UiText>
                    </Checkbox>
                ))}
            </div>
            <UiButton
                type="button"
                className={cls.settingsAction}
                btnText={t('button.save.text')}
                disabled={isPending}
                onClick={save}
            />
        </section>
    );
};
